export const errorText = `
کاربر محترم بعلت  عدم پاسخگویی سرویس های  احراز هویت لطفا بعدا مجدد  تلاش فرمایید 
`